import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nextDayPhone" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'NextDayPhone',
  setup(__props) {

initEmptyParam()
const store = useStore()


const queryParam = {
  sysDate: dayjs().startOf('date').format('YYYY-MM-DD')
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}
const getDept = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  const deptOptions = deptList.map((item: any) => {
    return {title: item.name, value: item.id};
  })
  const deptItem = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  deptItem!.options = deptOptions
}
getDept()
// 定义筛选规则
const filterRules = [
  '筛选规则：',
  '1、每天早上6点，记录昨日的直播客户数据',
  '2、每天早上8点，组装需要通知业务员的昨日观看直播客户的数据列表',
  '3、每天下午5点，检查当日业务员的直播客户的通话情况',
  '4、每天晚上7点，组装需要通知业务员的昨日观看直播客户的通话情况数据列表',
  '5、每天早晨7点，更新昨日业务员的直播客户通话情况数据'
]
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      labelWidth: '150px'
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "nextDayPhone",
      pageUrl: "/liveCustomerFollowup/queryByCondition",
      downUrl: "/liveCustomerFollowup/download",
      downFilename: "直播客户次日电话情况.xlsx",
      filterRules: filterRules,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})